import { mergeQueryParameters } from '@packages/shared/src/utils/mergeQueryParameters/mergeQueryParameters';
import {
  encodeDisplayMode,
  encodePage,
  encodePageSize,
  encodeOrder,
  encodeCategoryFilter,
  encodeSelectedFilterValues,
} from '../../queryEncoding';

/** Return a key that determines, by changing, when the seen products count should reset (and the tracking event should be sent) */
export const getPageLeaveKey = (url: string) => {
  // changes in these parameters should NOT be considered a "page leave"
  // the actual values here don't matter, we just need the keys, but don't want to hardcode them
  // logically grouped it's: paging, display mode, sorting, filtering
  const parametersToStrip = Object.keys({
    ...encodePage(),
    ...encodePageSize(),
    ...encodeDisplayMode('cards'),
    ...encodeOrder('relevance'),
    ...encodeCategoryFilter('1234'),
    ...encodeSelectedFilterValues({ foo: ['bar'] }),
  });

  // strip all irrelevant params from the url, leaving an URL that only changes when the number of seen products should also send/reset
  const relevantUrl = mergeQueryParameters(
    url,
    Object.fromEntries(parametersToStrip.map((key) => [key, undefined])),
  );

  return relevantUrl;
};
